import Alpine from '@alpinejs/csp'
import focus from '@alpinejs/focus'

import './plugins/Craft';
import './plugins/headroom';
import initAccordionItem from './components/accordion';
import initHeaderVideo from './components/headerVideo';
import initInpageNav from './components/inpageNav';
import initStyles from './components/jsStyles';
import initMenu from './components/menu';
import initRevealContactLink from './components/revealContactLink';
import initResults from './components/results';
import initVideo from './components/video';
import initVideoSlider from './components/videoSlider';
import initDisclaimer from './components/disclaimer';
import initCookieConsent from "./components/cookieConsent";
import initAdobePdfViewer from './components/adobe-pdf-viewer';

window.Alpine = Alpine;
Alpine.plugin(focus);

const startingWith = (subject: string, replacement: string ) => ({ name , value }: { name: string, value: string }) => {
  if (name.startsWith(subject)) {
    name = name.replace(subject, replacement);
  }
  return { name, value };
}

document.addEventListener('DOMContentLoaded', () => {
  initStyles();
})
document.addEventListener('alpine:init', () => {
  Alpine.prefix('data-x-');
  Alpine.mapAttributes(startingWith('data-x-show', Alpine.prefixed('show')));
  Alpine.mapAttributes(startingWith('data-x-on.', Alpine.prefixed('on:')));
  Alpine.mapAttributes(startingWith('data-x-ref', Alpine.prefixed('ref')));
  Alpine.mapAttributes(startingWith('data-x-bind.', Alpine.prefixed('bind:')));
  Alpine.mapAttributes(startingWith('data-x-cloak', Alpine.prefixed('cloak')));
  Alpine.mapAttributes(startingWith('data-x-transition.', Alpine.prefixed('transition:')));
  initAccordionItem();
  initCookieConsent();
  initDisclaimer()
  initHeaderVideo();
  initInpageNav();
  initMenu();
  initRevealContactLink();
  initResults();
  initVideo();
  initVideoSlider();
  initAdobePdfViewer();
});

Alpine.start();

if (import.meta.hot) {
  import.meta.hot.accept(() => {
     
    console.log('HMR');
  });
}
